import { Component, input, output } from '@angular/core';
import { NgClass } from '@angular/common';
import { SafeHtml } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { MenuSection } from '../../../services/menu.service';
import type { NavMode } from '../topbar.types';

/** Un element de la fenetre d'une section du dock. */
export interface DockWindowItem {
  name: string;
  desc: string;
  gradient: string;
  svgIcon: string;
  route: string;
}

/** Ce que le dock demande a la barre : dessiner une icone (une valeur que la barre assainit). */
export interface TopbarDockPort {
  svgFor(svgInner?: string, size?: number): SafeHtml;
}

/**
 * Mode « dock » de la barre du haut : la fenetre d'une section et le dock lui-meme.
 *
 * Presentationnel : il affiche les sections du menu et la fenetre ouverte, et emet l'intention
 * (ouvrir une section, naviguer, fermer la fenetre, choisir un element). Le magnetisme du dock
 * reste a la barre, qui cherche `.dock` dans son propre element.
 */
@Component({
  selector: 'app-topbar-dock',
  standalone: true,
  imports: [NgClass, TranslateModule],
  templateUrl: './topbar-dock.component.html',
  styleUrls: [
    '../styles/topbar-partage-02.css',
    '../styles/topbar-partage-05.css',
    '../styles/topbar-dock-01.css',
    '../styles/topbar-partage-06.css',
    '../styles/topbar-dock-02.css',
  ],
  styles: [':host { display: contents; }'],
})
export class TopbarDockComponent {
  readonly showWindow = input.required<boolean>();
  readonly windowTitle = input.required<string>();
  readonly windowItems = input.required<DockWindowItem[]>();
  readonly navMode = input.required<NavMode>();
  readonly menuSections = input.required<MenuSection[]>();
  readonly dashboardDockSvg = input.required<SafeHtml>();
  readonly port = input.required<TopbarDockPort>();

  readonly windowClosed = output<void>();
  readonly windowItemClicked = output<string>();
  readonly dockWindowOpened = output<{ labelKey: string; key: string }>();
  readonly navigated = output<string>();
}
